import { useState, useEffect } from 'react';
import { Topbar, Sidebar, ClientData, Loader, Suspend, Verify } from "../../../components";
import { authStaff } from "../../../utils/constants";
import { adminPortalRequest } from "../../../Requests/getRequests";
import { useDispatch, useSelector } from "react-redux";
import { selectAccessToken, selectStaffId } from "../../../slices/staffSlice";
import { show } from '../../../slices/toastSlice';
import { useNavigate, Link } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { UserIcon, ArrowLeft01Icon } from '@hugeicons/core-free-icons';

function Edit() {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const clientId = useSelector(selectStaffId);
    const [client, setClient] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getUserDetails = async () => {
            const res = await adminPortalRequest(`/auth/staff/client/find`, "GET", authStaff(accessToken), { _id: clientId }, {});

            if (res?.code === 401) {
                sessionStorage.clear();
                navigate("/login");
                dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
                return;
            }
            if (res?.err) {
                dispatch(show({ type: "error", state: true, message: res.err }));
                return;
            }
            setLoading(false);
            setClient(res);
        };

        getUserDetails();
    }, [accessToken, clientId, dispatch, navigate]);

    return (
        <div className="main-container">
            <Topbar />
            <Sidebar />

            <main className="main-content">
                <section className="section-container space-y-5">

                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <Link
                                to="/admin/clients"
                                className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 transition-colors"
                            >
                                <HugeiconsIcon icon={ArrowLeft01Icon} size={15} />
                                Clients
                            </Link>
                            <span className="text-gray-300">/</span>
                            <div className="flex items-center gap-2">
                                <div className="w-7 h-7 rounded-lg bg-purple-50 border border-purple-100 flex items-center justify-center shrink-0">
                                    <HugeiconsIcon icon={UserIcon} size={14} className="text-purple-600" />
                                </div>
                                <span className="text-sm font-medium text-gray-700">
                                    {loading ? 'Loading...' : `${client?.otherNames} ${client?.surname}`}
                                </span>
                            </div>
                        </div>

                        {!loading && client && (
                            <div className="flex items-center gap-2">
                                <Verify status={client?.isVerified} />
                                <Suspend _id={client?._id} status={client?.isDisabled} />
                            </div>
                        )}
                    </div>

                    {loading ? (
                        <div className="flex items-center justify-center py-16">
                            <Loader color="text-gray-400" size="w-6 h-6" />
                        </div>
                    ) : (
                        <ClientData client={client} />
                    )}

                </section>
            </main>
        </div>
    );
}

export default Edit;
